import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Style/SubjectTopics.css';
import SubjectTopicName from '../AllData/SubjectTopicName';
import Loading from '../home/Loading';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';


function QuizSubjectTopics(props) {
  const [topicsList, setTopicsList] = useState([]);
  const topicsName = SubjectTopicName;
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    const filteredTopicsName = topicsName.filter(topics =>
      topics.topicssubject === props.subject && topics.topicstype === "mocktest"
    );
    setTopicsList(filteredTopicsName);
    setLoading(false);
  }, [topicsName, props.subject]);


  if (loading) {
    return <Loading message="Loading......." />;
  }

  return (
    <div className="subject-topics-page">

      <TopNavbar name={"Topics wise  " + props.subject} />
      <TopHeader name={"Topics wise  " + props.subject} />


      <div className="topics-container">

        <Link to={`/quiz-number/${props.type}/${props.subject}/${props.topic}/${props.subjectName}`} className="link">
          <div className="topic-card">
            <div className="topic-header">
              <p style={{color: "blue", fontSize: "14px"}}>📋 Full {props.subject} mock test</p>
            </div>
          </div>

        </Link>


        {topicsList.map((topic) => {
          return (
            <Link to={`/quiz-number/${props.type}/${props.subject}/${topic.topicssymbol}/${topic.topicsname.substring(2)}`} className="link">

              <div key={topic.id} className="topic-card">
                <div className="topic-header">
                  <p style={{color: "blue", fontSize: "14px"}}>📋{topic.topicsname.length > 37 ? `${topic.topicsname.substring(0, 35)}...` : topic.topicsname} </p>
                </div>
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  );
}

export default QuizSubjectTopics;